import React, { CSSProperties, useMemo } from 'react';
import './ElectricBorder.css';

type ElectricBorderProps = {
    children?: React.ReactNode;
    color?: string;
    speed?: number;
    chaos?: number; // Deprecated
    thickness?: number;
    className?: string;
    style?: CSSProperties;
};

const ElectricBorder: React.FC<ElectricBorderProps> = ({
    children,
    color = '#5227FF',
    speed = 1,
    thickness = 2,
    className,
    style
}) => {
    const duration = Math.max(0.2, 3 / (speed || 1)) + 's';

    const vars: CSSProperties = {
        ['--electric-border-color' as any]: color,
        ['--eb-border-width' as any]: `${thickness}px`,
        ['--eb-speed' as any]: duration
    } as React.CSSProperties;

    // Generate 12 particles with varied orbits
    const particles = useMemo(() => {
        return Array.from({ length: 12 }).map((_, i) => {
            // Moderate tilts: enough to look 3D but not so extreme they never go "behind"
            const tiltX = 30 + Math.random() * 50; // 30-80 deg
            const tiltY = (Math.random() - 0.5) * 60; // -30 to 30 deg

            // Tighter radius: 55-85px range
            const radius = 55 + Math.random() * 30;

            return {
                id: i,
                style: {
                    '--p-speed': `${2.5 + Math.random() * 2}s`,
                    '--p-delay': `-${Math.random() * 4.5}s`,
                    '--p-wobble-speed': `${6 + Math.random() * 4}s`,
                    '--p-orbit-tilt-x': `${tiltX}deg`,
                    '--p-orbit-tilt-y': `${tiltY}deg`,
                    '--p-orbit-radius': `${radius}px`
                } as React.CSSProperties
            };
        });
    }, []);

    return (
        <div className={`electric-border ${className ?? ''}`} style={{ ...vars, ...style }}>
            <div className="electric-border-static" />

            {/* Fireflies Container */}
            <div className="eb-particle-container">
                {particles.map(p => (
                    <div key={p.id} className="eb-particle-track" style={p.style}>
                        <div className="eb-particle" />
                    </div>
                ))}
            </div>

            <div className="eb-content">
                {children}
            </div>
        </div>
    );
};

export default ElectricBorder;
